import React, { CSSProperties } from 'react';
import './divider.scss';
import { DividerColorVariant } from '../../constants';

interface DividerProps {
  colorVariant?: DividerColorVariant | CSSProperties['color'];
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({
  colorVariant = DividerColorVariant.DEFAULT,
  className = '',
}) => {
  return (
    <div className={`divider-container ${colorVariant} ${className}`.trim()} />
  );
};
